import { Component, OnInit } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO} from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';


@Component({
  selector: 'app-chapter-admin',
  templateUrl: './chapter-admin.component.html',
  styleUrls: ['./chapter-admin.component.css']
})
export class ChapterAdminComponent implements OnInit {
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string;
  chapterId: number;
  createdBy: any = this.loginData.userId;
  createdDateTime: any;
  modifiedBy: any  = this.loginData.userId;
  modifiedDateTime: any;
  userId: any;
  adminId: any  = localStorage.getItem('adminId');
  numberOfElements:number;
  currentPage = 0;
  currentNumberOfElements:number = ConstantValues.pageLimit;
  totalPages = 0;
  roleList : any;
  tableShow: any;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  searchTerm : any;
  siteData: any;
  siteList: any;
  selectedErgsData: any;
  ergList: any;
  selectedSiteId: any = localStorage.getItem('userSiteId');
  selectedErgId: any;
  selectedSite: any;
  siteAndPath: any;
  selectedBpg: any;
  allErgIds: any[]=[];
  landingData:any;
  loginUserAdminId: any = localStorage.getItem('adminId');
  tableresp : boolean;
  ergNotSelected : boolean;
  userNotSelected : boolean;
  roleNotSelected :boolean;
  loginDetails:any = JSON.parse(localStorage.getItem("loginData"));
  loginDataDetails:any;
  userAndRoleIdDTO:any
  
  chapterList: any;
  chapterIds:any;
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  leadAdminId:any = localStorage.getItem('leadAdminId');
  bpgId :any;
  isErgAdmin = false;
  isErgLeadAdmin = false;
  constructor(private readonly userService: SelfService, 
    private readonly adminService: BpgAdminServices, 
    private readonly spinner: Ng4LoadingSpinnerService,
    
    private readonly bpgCommonService: BpgCommonService,
    private readonly router: Router,
    private readonly environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
      if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {
        this.router.navigate(['/log-out']);
        }
    }

    if (localStorage.getItem('logOutFlag') === "true"){
        this.router.navigate(['/log-out']); 
     
    }

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isErgAdmin = true
     }
     if(localStorage.getItem('isbpgLeadAdmin') === 'true')
     {
       this.isErgLeadAdmin = true;
      }
    this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
    localStorage.removeItem('searchedEventsCaledarItems');
    if(this.leadAdminId  === 'true' && !this.isErgAdmin)
    {
      localStorage.setItem('adminId','2');  

    }
    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')
    }
    if(this.adminId !== '1' && (this.adminId !== '2' && this.leadAdminId !== 'true'))
    {
      this.router.navigate(['/site-home']);
    }
    this.spinner.show();
    sessionStorage.removeItem("MembershipData");

    if(this.loginUserAdminId === '1' || this.loginUserAdminId === '2' || this.isErgLeadAdmin){
    this.getSiteList();
    this.getErgList();    
    }
    
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.LandingPaginationDTO.sortProperty = "user_first_name";
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";
   if(this.loginUserAdminId === '1'){
    this.roleList =[
      {"roleName":"ERG Admin",
       "roleId":3
      },
      { "roleName":"ERG Lead Admin",
       "roleId":2
      }
    ]
   } 

   if(this.loginUserAdminId === '2' || this.isErgLeadAdmin){
    this.roleList =[
      {"roleName":"ERG Admin",
       "roleId":3
      }
    ]
   }  
  
  
    this.createdDateTime = new Date();
    this.modifiedDateTime = new Date();


    this.loginUserId = this.loginData.userId;
    if(window.innerWidth<767){
      this.tableresp = true;
    }else{
      this.tableresp = false;
    }
    
    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);
  
  }
/** get site name in the dropdown for lead admin
  * @class ChapterAdminComponent
  * @method getSiteName
  */
  getSiteName(){
    this.selectedSite = this.loginData.site.siteName; 
    this.selectedSiteId = localStorage.getItem('userSiteId');  
  }

/** get site list in the dropdown
  * @class ChapterAdminComponent
  * @method getSiteList
  */
 getSiteList(){
   if(this.adminId === '1')
   {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
   }
   if(this.adminId === '2' || this.isErgLeadAdmin)
   {
    this.siteData = {
      "filter": { "adminId":this.loginUserAdminId,
      "userId": this.createdBy},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
   }
  
  this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
    this.siteList = data;
    //filter default site from sitelist
    this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT'); 
    if(this.siteList !== null){
      for(const site of this.siteList){
        if(site.siteId === Number(this.selectedSiteId) ){
          this.selectedSite = site.siteName;
        }
      }
    }
  });
 }

/** get bpg list in the dropdown
  * @class ChapterAdminComponent
  * @method getBpgList
  */
 getErgList(){
 this.selectedErgsData =
      {
        "filter": {
          "siteId": this.selectedSiteId,
          "adminId":this.loginUserAdminId,
          "userId": this.createdBy,
          "isLeadAdmin":this.leadAdminId
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }
    this.bpgCommonService.getMyBPGsList(this.selectedErgsData).subscribe(data => {
      this.ergList = data;
      if(this.ergList != null){
        for(let i=0;i<this.ergList.length;i++){
          if (i === 0) {
            this.bpgId = this.ergList[i].bpgId;
          }
          else {
            this.bpgId = `${this.bpgId},${this.ergList[i].bpgId}`;
          }
        }
        }
      this.listAdmins();

      if(this.ergList.length === 0){
        this.ergList.unshift({bpgId: 0, bpgName: 'No Data found'});

      }
      if(this.ergList != null){
        this.ergList.unshift({bpgId: 0, bpgName: '--Select ERG--'});
        for(const bpg of this.ergList){
          this.allErgIds.push(bpg.bpgId);
          if(bpg.bpgId === this.selectedErgId ){
            this.selectedBpg = bpg.bpgName;            
          }
        }   
      }
    });
  } 
  /** get chapter id 
  * @class ChapterAdminComponent
  * @method getChapterIds
  */
  getChapterIds(){
    this.landingData = {
      "filter":{"bpgId":this.selectedErgId,
      "siteId": this.selectedSiteId
        },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
     this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if(data!=null){
        for(const d of data){
          this.chapterId = d;
        }
      }   
     });
  }
 
  /** to list admins in table
  * @class ChapterAdminComponent
  * @method listAdmins
  */
 

 listAdmins() {
  this.timeOutError = false;
  this.spinner.show();
  this.LandingPaginationDTO.filter={"createdBy":this.createdBy,
  "adminId":this.loginUserAdminId,
  // "chapterId":this.chapterIds,
    "bpgId":this.bpgId,
   "siteId":this.selectedSiteId };
   this.adminService.getAllChapterAdmins(this.LandingPaginationDTO).subscribe(data => {    
   this.adminData = data.content; 
   if (this.adminData.length === 0) {
      this.tableShow = false;
      this.noDataFound = true;
	  setTimeout(function () {
        this.spinner.hide();
      }.bind(this), 100);

    } else {
      this.tableShow = true;
      this.noDataFound = false;
      setTimeout(function () {
        this.spinner.hide();
      }.bind(this), 5000);
      
    }
    this.numberOfElements = data.totalElements;
  },
  err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });
  
}

/** to list users other than admins
  * @class ChapterAdminComponent
  * @method getUserList
  */

 getUserList() {
  this.timeOutError = false;
  this.landingDto.filter = {"siteId": this.selectedSiteId,
                            "bpgId": this.selectedErgId,
                            "leadershipPosition":"EMPLOYEE"};

  this.userService.getUserDropDown(this.landingDto).subscribe(data => {
    this.userList = data; 
    this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
  }, err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });
}

 /** When select a user Populate the user details such as email and workId 
* @class ChapterAdminComponent
* @method getUserList
*/

userSelection(selectedUser) {
  for (const user of this.userList) {
    if (user != null) {
      if (selectedUser.userId === user.userId) {
        this.userId = user.userId;
      }
    }
  }
}

/** When select a role such as super admin or naac representative 
* @class ChapterAdminComponent
* @method roleSelection
*/

roleSelection(role) {
  if (role.roleName === "ERG Admin") {
    this.adminId = '3';
  }
  else if (role.roleName === "ERG Lead Admin") {
    this.adminId = '2';
  }
}

/** For site change from site list 
   * @class ChapterAdminComponent
   * @method siteChange
   * @returns Promise
   */
  siteChange(event) {
    this.clearError();
    this.selectedErgId = null;
    this.selectedBpg= null;
    this.userFirstName=null;
    this.userId=null;
    this.selectedSiteId = event.siteId;
    this.ergList = [];
    this.getErgList();
  }
 /** For bpg change from bpg list 
   * @class ChapterAdminComponent
   * @method bpgChange
   * @returns Promise
   */

  ergChange(event) {
    this.selectedErgId=null;
    this.userFirstName=null;
    this.userId=null;
    this.selectedErgId = event.bpgId;   
    this.getChapterIds();     
    this.getUserList();
  }

/** to add new admin
  * @class ChapterAdminComponent
  * @method onSubmit
  */
 onSubmit() {
  this.timeOutError = false;
  this.spinner.show();
  const data = {                        
    "createdBy": this.createdBy,
    "createdDateTime": this.createdDateTime,
    "isActive": true,
    "modifiedBy": this.modifiedBy,
    "modifiedDateTime": this.modifiedDateTime,
    "userId": this.userId,
    "userRoleMappingId": 0,
    "adminId": parseInt(this.adminId),
    "bpgId": this.selectedErgId,
    "chapterId":this.chapterId
  }

  this.adminService.saveChapterAdmin(data).subscribe(data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if(data.message){ 
      this.errorMsg = data.message;
      this.alertFailure = true;
    }  
    else {
      this.alertSuccess = true;
    }
    
    this.listAdmins();
    this.getUserList();
    this.spinner.hide();
  },
  err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  }); 

}

/**to delete admin
* @class ChapterAdminComponent
* @method delete
*/

delete(data) {
  this.clearError();
  this.method = "deleteAdmin";
  this.param = data;
  this.msg1 = "Are you sure you want to delete this admin ?";
}

deleteAdmin(data) {
  this.timeOutError = false;
  this.adminService.deleteChapterAdmin(data).subscribe(_data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.deleteSuccess = true;
    this.listAdmins();
    this.getUserList();   
  },
  err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  });  
}

/** For filtering data by current page 
 * @class AdminComponent
 * @method pageChanged
 * @params event
 */
pageChanged(event) {
  this.clearError(); 
  this.LandingPaginationDTO.page = event - 1;
  this.currentPage = event;

  if ((this.currentPage * this.limit) < this.numberOfElements) {
    this.currentShowingElements = this.currentPage * this.limit;
  } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
    this.currentShowingElements = this.numberOfElements;
  }
  this.listAdmins();
}

  /** For sorting the table through columns
 * @class AdminComponent
 * @method sortMe
 */

public sortMe(sortingby) {
  this.clearError(); 
  if (this.LandingPaginationDTO.sortDirection === "ASC") {
    this.LandingPaginationDTO.sortDirection = "DESC";
    document.getElementById(sortingby + "1").classList.add("fading");
    document.getElementById(sortingby + "2").classList.remove("fading");
  } else {
    this.LandingPaginationDTO.sortDirection = "ASC";
    document.getElementById(sortingby + "2").classList.add("fading");
    document.getElementById(sortingby + "1").classList.remove("fading");
  }

  this.LandingPaginationDTO.sortProperty = sortingby;
  this.listAdmins();
}

   /** For searching the table through keywords
 * @class AdminComponent
 * @method searchMe
 */
searchMe() {
  this.clearError(); 
  this.spinner.show();
  this.searchKey = (this.searchKey) ? this.searchKey : '';
  this.LandingPaginationDTO.page = 0;
  this.LandingPaginationDTO.searchTerm = this.searchKey;
  this.currentPage = 1;
  this.listAdmins();
  this.spinner.hide();
}

  /** Confirm on save
   * @class AdminComponent
   * @method submit
   */
  submit(){

    if(this.selectedErgId === null || this.selectedErgId === ""){
      this.ergNotSelected = true;     
      return;
    }
    if(this.userId === null || this.userId === ""){
      this.clearError();
      this.userNotSelected = true;         
      return;
    }
    if(this.adminId === null || this.adminId === "" || this.roleName === null){
      this.clearError(); 
      this.roleNotSelected = true;           
      return;
    } 
    this.clearError(); 
    document.getElementById("submitButton").setAttribute('data-toggle','modal');
    document.getElementById("submitButton").setAttribute('data-target','#myModal');

    this.method = "onSubmit";
    this.param = '';
    this.msg1="Do you want to add admin ?";
  }

  reset(){

    this.method = "resetClick";
    this.param = '';
    this.msg1="Your current changes will be discarded. Do you want to continue ?";

  }
 /** Confirm on reset
   * @class AdminComponent
   * @method resetClick
   */
  resetClick(){
    this.roleName = null;
    this.userFirstName = null;
    this.selectedBpg= null;
    this.selectedErgId=null;
    this.userId = null;
    this.adminId = null;
    this.clearError(); 
    this.searchKey=null;
    this.LandingPaginationDTO.searchTerm= null;
    this.getSiteName();  
    this.getErgList();   
    this.listAdmins();
}

 /** For clearing errors
   * @class ChapterAdminComponent
   * @method clearError
   */
  clearError() {   
    this.ergNotSelected = false; 
    this.userNotSelected = false;
    this.roleNotSelected = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.deleteSuccess = false; 
    document.getElementById("submitButton").removeAttribute('data-toggle');
    document.getElementById("submitButton").removeAttribute('data-target');  
  }
}
